const getColor = (value) => {
  if (Number(value) >= 1) {
    return {
      background: 'rgba(68, 193, 152, 1)',
      color: '#fff'
    }
  } else if (Number(value) >= 0.75) {
    return {
      background: 'rgba(68, 193, 152, 1)',
      color: '#fff'
    }
  } else if (Number(value) >= 0.6) {
    return {
      background: 'rgba(187, 247, 208, 1)',
      color: '#000'
    }
  } else if (Number(value) >= 0.45) {
    return {
      background: 'rgba(220, 252, 231, 1)',
      color: '#000'
    }
  } else if (Number(value) >= 0.35) {
    return {
      background: 'rgba(254, 240, 138, 1)',
      color: '#000'
    }
  } else if (Number(value) >= 0.25) {
    return {
      background: 'rgba(254, 249, 195, 1)',
      color: '#000'
    }
  } else if (Number(value) >= 0.1) {
    return {
      background: 'rgba(254, 252, 232, 1)',
      color: '#000'
    }
  } else if (Number(value) >= 0.00001) {
    return {
      background: '#FFFBEB',
      color: '#000'
    }
  } else
    return {
      background: 'transparent',
      color: '#000'
    }
}

export const columnData = [
  {
    title: '日期',
    sortable: true,
    fixed: 'left',
    width: 120,
    index: '1',
    key: 'statDate',
    always: true
  },
  {
    title: '广告名称',
    sortable: true,
    only: 'address',
    tooltip: true,
    tooltipMaxWidth: 300,
    maxWidth: 200,
    width: 140,
    index: '114',
    key: 'adName',
    always: true
  },
  {
    title: '广告组',
    sortable: true,
    width: 140,
    tooltip: true,
    tooltipMaxWidth: 300,
    maxWidth: 200,
    only: 'adset,address',
    index: '112',
    key: 'adSetName'
  },
  {
    title: '广告系列名称',
    sortable: true,
    index: '108',
    width: 140,
    tooltip: true,
    tooltipMaxWidth: 300,
    maxWidth: 200,
    key: 'campaignName',
    only: 'campaign,adset,address'
  },
  {
    title: '短剧信息',
    sortable: true,
    width: 140,
    tooltip: true,
    tooltipMaxWidth: 300,
    maxWidth: 200,
    index: '102',
    key: 'playName',
    only: 'campaign,adset,address',
    render: (h, params) => {
      return <Tooltip style="width:100%" transfer>
        <div style={{whiteSpace: 'nowrap', width: '100%', textOverflow: 'ellipsis', overflow: 'hidden'}}>{params.row.playId+'-'+params.row.playChineseName}</div>
        <div slot="content">
          <p style={{ whiteSpace: 'nowrap' }}>
            {params.row.playChineseName}
          </p>
        </div>
      </Tooltip>
    }
  },
  {
    title: '语言',
    sortable: false,
    width: 140,
    index: '1002',
    key: 'langName',
    only: 'campaign,adset,address'
  },
  {
    title: '优化师',
    sortable: true,
    width: 100,
    index: '100',
    key: 'person'
  },
  {
    title: '推广目标',
    sortable: true,
    width: 120,
    index: '104',
    key: 'advertiseTypeName',
    only: 'campaign,adset,address'
  },
  {
    title: '推广渠道',
    sortable: true,
    width: 120,
    index: '106',
    key: 'channelName',
    only: 'campaign,adset,address'
  },
  {
    title: '广告系列状态',
    width: 140,
    index: '110',
    only: 'campaign',
    key: 'campaignStatusName'
  },
  {
    title: '查看',
    width: 120,
    only: 'campaign',
    index: '1122',
    key: 'status'
  },
  {
    title: '消耗',
    sortable: true,
    width: 100,
    index: '2',
    key: 'cost'
  },
  {
    title: '新用户数',
    sortable: true,
    width: 120,
    index: '3',
    notFixed: true,
    key: 'userCountNew'
  },
  {
    title: '染色用户数',
    sortable: true,
    width: 120,
    notFixed: true,
    index: '4',
    key: 'userCountAll'
  },
  {
    title: '激活用户数',
    sortable: true,
    width: 120,
    notFixed: true,
    index: '5',
    key: 'activeUserCount'
  },
  {
    title: '新用户占比',
    sortable: true,
    needCalc: true,
    width: 120,
    index: '6',
    key: 'userCountPrecentNew',
    render: (h, params) => {
      return (
        <div>
          {params.row.userCountPrecentNew
            ? (Number(params.row.userCountPrecentNew) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '染色用户占比',
    sortable: true,
    needCalc: true,
    width: 130,
    index: '7',
    key: 'userCountPrecentAll',
    render: (h, params) => {
      return (
        <div>
          {params.row.userCountPrecentAll
            ? (Number(params.row.userCountPrecentAll) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '新用户激活成本',
    sortable: true,
    width: 140,
    index: '8',
    key: 'activationCostNew',
    flag: 1,
    render: (h, params) => {
      return (
        <div>
          {params.row.activationCostNew
            ? Number(params.row.activationCostNew).toFixed(2)
            : 0}
        </div>
      )
    }
  },
  {
    title: '染色用户激活成本',
    sortable: true,
    width: 160,
    index: '9',
    key: 'activationCostAll',
    flag: 2,
    render: (h, params) => {
      return (
        <div>
          {params.row.activationCostAll
            ? Number(params.row.activationCostAll).toFixed(2)
            : 0}
        </div>
      )
    }
  },
  {
    title: '首日ROI',
    sortable: true,
    width: 100,
    index: '22',
    needCalc: true,
    key: 'firstROINew',
    flag: 1,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.firstROINew)
          }}
        >
          {params.row.firstROINew
            ? (Number(params.row.firstROINew) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '首日ROI',
    sortable: true,
    width: 100,
    index: '23',
    needCalc: true,
    key: 'firstROIAll',
    flag: 2,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.firstROIAll)
          }}
        >
          {params.row.firstROIAll
            ? (Number(params.row.firstROIAll) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '3日ROI',
    sortable: true,
    width: 100,
    index: '24',
    needCalc: true,
    key: 'thirdROINew',
    flag: 1,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.thirdROINew)
          }}
        >
          {params.row.thirdROINew
            ? (Number(params.row.thirdROINew) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '3日ROI',
    sortable: true,
    needCalc: true,
    width: 100,
    index: '25',
    key: 'thirdROIAll',
    flag: 2,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.thirdROIAll)
          }}
        >
          {params.row.thirdROIAll
            ? (Number(params.row.thirdROIAll) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '8日ROI',
    sortable: true,
    needCalc: true,
    width: 100,
    index: '26',
    key: 'eighthROINew',
    flag: 1,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.eighthROINew)
          }}
        >
          {params.row.eighthROINew
            ? (Number(params.row.eighthROINew) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '8日ROI',
    sortable: true,
    width: 100,
    needCalc: true,
    index: '27',
    key: 'eighthROIAll',
    flag: 2,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.eighthROIAll)
          }}
        >
          {params.row.eighthROIAll
            ? (Number(params.row.eighthROIAll) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '15日ROI',
    sortable: true,
    width: 110,
    needCalc: true,
    index: '28',
    key: 'fifthROINew',
    flag: 1,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.fifthROINew)
          }}
        >
          {params.row.fifthROINew
            ? (Number(params.row.fifthROINew) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '15日ROI',
    sortable: true,
    width: 110,
    index: '29',
    needCalc: true,
    key: 'fifthROIAll',
    flag: 2,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.fifthROIAll)
          }}
        >
          {params.row.fifthROIAll
            ? (Number(params.row.fifthROIAll) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '30日ROI',
    sortable: true,
    width: 110,
    index: '30',
    needCalc: true,
    key: 'thirtyROINew',
    flag: 1,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.thirtyROINew)
          }}
        >
          {params.row.thirtyROINew
            ? (Number(params.row.thirtyROINew) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '30日ROI',
    sortable: true,
    width: 110,
    index: '31',
    key: 'thirtyROIAll',
    needCalc: true,
    flag: 2,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.thirtyROIAll)
          }}
        >
          {params.row.thirtyROIAll
            ? (Number(params.row.thirtyROIAll) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '60日ROI',
    sortable: true,
    needCalc: true,
    width: 110,
    index: '32',
    key: 'sixtyROINew',
    flag: 1,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.sixtyROINew)
          }}
        >
          {params.row.sixtyROINew
            ? (Number(params.row.sixtyROINew) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '60日ROI',
    sortable: true,
    width: 110,
    needCalc: true,
    index: '33',
    key: 'sixtyROIAll',
    flag: 2,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ...getColor(params.row.sixtyROIAll)
          }}
        >
          {params.row.sixtyROIAll
            ? (Number(params.row.sixtyROIAll) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '首日充值金额',
    sortable: true,
    width: 130,
    index: '10',
    key: 'firstRechargeNew',
    flag: 1
  },
  {
    title: '首日充值金额',
    sortable: true,
    width: 130,
    index: '11',
    key: 'firstRechargeAll',
    flag: 2
  },
  {
    title: '3日充值金额',
    sortable: true,
    width: 130,
    index: '12',
    key: 'thirdRechargeNew',
    flag: 1
  },
  {
    title: '3日充值金额',
    sortable: true,
    width: 130,
    index: '13',
    key: 'thirdRechargeAll',
    flag: 2
  },
  {
    title: '8日充值金额',
    sortable: true,
    width: 130,
    index: '14',
    key: 'eighthRechargeNew',
    flag: 1
  },
  {
    title: '8日充值金额',
    sortable: true,
    width: 130,
    index: '15',
    key: 'eighthRechargeAll',
    flag: 2
  },
  {
    title: '15日充值金额',
    sortable: true,
    width: 140,
    index: '16',
    key: 'fifthRechargeNew',
    flag: 1
  },
  {
    title: '15日充值金额',
    sortable: true,
    width: 140,
    index: '17',
    key: 'fifthRechargeAll',
    flag: 2
  },
  {
    title: '30日充值金额',
    sortable: true,
    width: 140,
    index: '18',
    key: 'thirtyRechargeNew',
    flag: 1
  },
  {
    title: '30日充值金额',
    sortable: true,
    width: 140,
    index: '19',
    key: 'thirtyRechargeAll',
    flag: 2
  },
  {
    title: '60日充值金额',
    sortable: true,
    width: 140,
    index: '20',
    key: 'sixtyRechargeNew',
    flag: 1
  },
  {
    title: '60日充值金额',
    sortable: true,
    width: 140,
    index: '21',
    key: 'sixtyRechargeAll',
    flag: 2
  },

  {
    title: '3日累充/首日充值',
    sortable: true,
    width: 150,
    index: '34',
    key: 'threeTimesGrowthNew',
    flag: 1,
    render: (h, params) => {
      return (
        <div>
          {params.row.threeTimesGrowthNew
            ? Number(params.row.threeTimesGrowthNew).toFixed(2)
            : 0}
        </div>
      )
    }
  },
  {
    title: '3日累充/首日充值',
    sortable: true,
    width: 250,
    index: '35',
    key: 'threeTimesGrowthAll',
    flag: 2,
    render: (h, params) => {
      return (
        <div>
          {params.row.threeTimesGrowthAll
            ? Number(params.row.threeTimesGrowthAll).toFixed(2)
            : 0}
        </div>
      )
    }
  },
  {
    title: '8日累充/首日充值',
    sortable: true,
    width: 150,
    index: '36',
    key: 'eighthTimesGrowthNew',
    flag: 1,
    render: (h, params) => {
      return (
        <div>
          {params.row.eighthTimesGrowthNew
            ? Number(params.row.eighthTimesGrowthNew).toFixed(2)
            : 0}
        </div>
      )
    }
  },
  {
    title: '8日累充/首日充值',
    sortable: true,
    width: 150,
    index: '37',
    key: 'eighthTimesGrowthAll',
    flag: 2,
    render: (h, params) => {
      return (
        <div>
          {params.row.eighthTimesGrowthAll
            ? Number(params.row.eighthTimesGrowthAll).toFixed(2)
            : 0}
        </div>
      )
    }
  },
  {
    title: '15日累充/首日充值',
    sortable: true,
    width: 160,
    index: '38',
    key: 'fifthTimesGrowthNew',
    flag: 1,
    render: (h, params) => {
      return (
        <div>
          {params.row.fifthTimesGrowthNew
            ? Number(params.row.fifthTimesGrowthNew).toFixed(2)
            : 0}
        </div>
      )
    }
  },
  {
    title: '15日累充/首日充值',
    sortable: true,
    width: 160,
    index: '39',
    key: 'fifthTimesGrowthAll',
    flag: 2,
    render: (h, params) => {
      return (
        <div>
          {params.row.fifthTimesGrowthAll
            ? Number(params.row.fifthTimesGrowthAll).toFixed(2)
            : 0}
        </div>
      )
    }
  },
  {
    title: '30日累充/首日充值',
    sortable: true,
    width: 160,
    index: '40',
    key: 'thirtyTimesGrowthNew',
    flag: 1,
    render: (h, params) => {
      return (
        <div>
          {params.row.thirtyTimesGrowthNew
            ? Number(params.row.thirtyTimesGrowthNew).toFixed(2)
            : 0}
        </div>
      )
    }
  },
  {
    title: '30日累充/首日充值',
    sortable: true,
    width: 160,
    index: '41',
    key: 'thirtyTimesGrowthAll',
    flag: 2,
    render: (h, params) => {
      return (
        <div>
          {params.row.thirtyTimesGrowthAll
            ? Number(params.row.thirtyTimesGrowthAll).toFixed(2)
            : 0}
        </div>
      )
    }
  },
  {
    title: '60日累充/首日充值',
    sortable: true,
    width: 160,
    index: '42',
    key: 'sixtyTimesGrowthNew',
    flag: 1,
    render: (h, params) => {
      return (
        <div>
          {params.row.sixtyTimesGrowthNew
            ? Number(params.row.sixtyTimesGrowthNew).toFixed(2)
            : 0}
        </div>
      )
    }
  },
  {
    title: '60日累充/首日充值',
    sortable: true,
    width: 160,
    index: '43',
    key: 'sixtyTimesGrowthAll',
    flag: 2,
    render: (h, params) => {
      return (
        <div>
          {params.row.sixtyTimesGrowthAll
            ? Number(params.row.sixtyTimesGrowthAll).toFixed(2)
            : 0}
        </div>
      )
    }
  },
  {
    title: '首日付费用户数',
    sortable: true,
    width: 140,
    notFixed: true,
    index: '44',
    key: 'paySuccessUserCountNew',
    flag: 1
  },
  {
    title: '首日付费用户数',
    sortable: true,
    width: 140,
    notFixed: true,
    index: '45',
    key: 'paySuccessUserCountAll',
    flag: 2
  },
  {
    title: '60日累计付费用户数',
    sortable: true,
    notFixed: true,
    width: 170,
    index: '46',
    key: 'sixtyDaysPaySuccessUserCountNew',
    flag: 1
  },
  {
    title: '60日累计付费用户数',
    sortable: true,
    width: 170,
    notFixed: true,
    index: '47',
    key: 'sixtyDaysPaySuccessUserCountAll',
    flag: 2
  },
  {
    title: '首日付费次数',
    sortable: true,
    width: 130,
    index: '48',
    key: 'paySuccessOrderCountNew',
    flag: 1
  },
  {
    title: '首日付费次数',
    sortable: true,
    width: 130,
    index: '49',
    key: 'paySuccessOrderCountAll',
    flag: 2
  },
  {
    title: '60日累计付费次数',
    sortable: true,
    width: 160,
    index: '50',
    key: 'sixtyDaysPaySuccessCountNew',
    flag: 1
  },
  {
    title: '60日累计付费次数',
    sortable: true,
    width: 260,
    index: '51',
    key: 'sixtyDaysPaySuccessCountAll',
    flag: 2
  },
  {
    title: '首日订阅人数',
    sortable: true,
    width: 140,
    index: '52',
    key: 'subscribeUserCountNew',
    flag: 1
  },
  {
    title: '首日订阅人数',
    sortable: true,
    width: 140,
    index: '53',
    key: 'subscribeUserCountAll',
    flag: 2
  },
  {
    title: '首日支付成功率',
    needCalc: true,
    sortable: true,
    width: 160,
    index: '54',
    key: 'firstDayPaySuccessPercentNew',
    flag: 1,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          {params.row.firstDayPaySuccessPercentNew
            ? (Number(params.row.firstDayPaySuccessPercentNew) * 100).toFixed(
                2
              ) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '首日支付成功率',
    sortable: true,
    width: 160,
    needCalc: true,
    index: '55',
    key: 'firstDayPaySuccessPercentAll',
    flag: 2,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          {params.row.firstDayPaySuccessPercentAll
            ? (Number(params.row.firstDayPaySuccessPercentAll) * 100).toFixed(
                2
              ) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '首日付费成本',
    sortable: true,
    width: 140,
    index: '56',
    key: 'firstDayPayCostNew',
    flag: 1,
    render: (h, params) => {
      return (
        <div>
          {params.row.firstDayPayCostNew
            ? Number(params.row.firstDayPayCostNew).toFixed(2)
            : 0}
        </div>
      )
    }
  },
  {
    title: '首日付费成本',
    sortable: true,
    width: 140,
    index: '57',
    key: 'firstDayPayCostAll',
    flag: 2,
    render: (h, params) => {
      return (
        <div>
          {params.row.firstDayPayCostAll
            ? Number(params.row.firstDayPayCostAll).toFixed(2)
            : 0}
        </div>
      )
    }
  },
  {
    title: '首日付费率',
    needCalc: true,
    sortable: true,
    width: 120,
    index: '58',
    key: 'firstDayPayPrecentNew',
    flag: 1,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          {params.row.firstDayPayPrecentNew
            ? (Number(params.row.firstDayPayPrecentNew) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '首日付费率',
    sortable: true,
    needCalc: true,
    width: 120,
    index: '59',
    key: 'firstDayPayPrecentAll',
    flag: 2,
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          {params.row.firstDayPayPrecentAll
            ? (Number(params.row.firstDayPayPrecentAll) * 100).toFixed(2) + '%'
            : 0}
        </div>
      )
    }
  },
  {
    title: '首日人均付费次数',
    sortable: true,
    width: 160,
    index: '60',
    key: 'firstDayAveragePayFrequencyNew',
    flag: 1
  },
  {
    title: '首日人均付费次数',
    sortable: true,
    width: 160,
    index: '61',
    key: 'firstDayAveragePayFrequencyAll',
    flag: 2
  },
  {
    title: '60日人均付费次数',
    sortable: true,
    width: 160,
    index: '62',
    key: 'sixtyDaysAveragePayFrequencyNew',
    flag: 1
  },
  {
    title: '60日人均付费次数',
    sortable: true,
    width: 160,
    index: '63',
    key: 'sixtyDaysAveragePayFrequencyAll',
    flag: 2
  },
  {
    title: '首日arppu',
    sortable: true,
    width: 120,
    index: '64',
    key: 'firstDayArppuNew',
    flag: 1,
    render: (h, params) => {
      return (
        <div>
          {params.row.firstDayArppuNew
            ? Number(params.row.firstDayArppuNew).toFixed(2)
            : 0}
        </div>
      )
    }
  },
  {
    title: '首日arppu',
    sortable: true,
    width: 120,
    index: '65',
    key: 'firstDayArppuAll',
    flag: 2,
    render: (h, params) => {
      return (
        <div>
          {params.row.firstDayArppuAll
            ? Number(params.row.firstDayArppuAll).toFixed(2)
            : 0}
        </div>
      )
    }
  },
  {
    title: '60日累计arppu',
    sortable: true,
    width: 150,
    index: '66',
    key: 'sixtyDaysArppuNew',
    flag: 1,
    render: (h, params) => {
      return (
        <div>
          {params.row.sixtyDaysArppuNew
            ? Number(params.row.sixtyDaysArppuNew).toFixed(2)
            : 0}
        </div>
      )
    }
  },
  {
    title: '60日累计arppu',
    sortable: true,
    width: 150,
    index: '67',
    key: 'sixtyDaysArppuAll',
    flag: 2,
    render: (h, params) => {
      return (
        <div>
          {params.row.sixtyDaysArppuAll
            ? Number(params.row.sixtyDaysArppuAll).toFixed(2)
            : 0}
        </div>
      )
    }
  },
  {
    title: '千次展示费用',
    sortable: true,
    width: 140,
    index: '68',
    key: 'thousandShowCost',
    render: (h, params) => {
      return (
        <div>
          {params.row.thousandShowCost
            ? Number(params.row.thousandShowCost).toFixed(2)
            : 0}
        </div>
      )
    }
  },
  {
    title: '点击率',
    sortable: true,
    width: 100,
    needCalc: true,
    notFixed: true,
    unit: '%',
    index: '69',
    key: 'ctr',
    render: (h, params) => {
      return (
        <div
          style={{
            position: 'absolute',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          {params.row.ctr ? (Number(params.row.ctr)).toFixed(2) + '%' : 0}
        </div>
      )
    }
  }
]
